<template>
  <div v-if="visible" class="ai-float-entry" @click.stop.prevent="goToMessageNotice">
    <img :src="floatIcon" :alt="$t('route.aiNoticeCenter')" class="float-icon" />
    <span v-if="aiNoticeUnread > 0" class="float-badge">{{ aiNoticeUnread > 99 ? '99+' : aiNoticeUnread }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { hasAiNoticePermission } from '@/utils/aiNoticePermission';
import floatIcon from '@/assets/ai-float-window-shadow.svg';

export default {
  name: 'AiFloatEntry',
  data() {
    return {
      floatIcon,
    };
  },
  computed: {
    ...mapGetters(['authList', 'hotelCode', 'aiNoticeUnread', 'isAiFloatSuppressed']),
    hasAiNoticePermission() {
      return hasAiNoticePermission(this.authList);
    },
    visible() {
      return !!this.hotelCode && this.hasAiNoticePermission && !this.isAiFloatSuppressed;
    },
  },
  methods: {
    goToMessageNotice() {
      this.$router.push({ path: '/ai/notice-entry' }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-float-entry {
  position: fixed;
  right: 28px;
  bottom: 104px;
  z-index: 2000;
  width: 70px;
  height: 70px;
  cursor: pointer;
  pointer-events: auto;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
  }

  .float-icon {
    display: block;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    box-shadow: 0 10px 24px rgba(31, 105, 255, 0.22);
    pointer-events: none;
  }

  .float-badge {
    position: absolute;
    top: -2px;
    right: -2px;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    border: 2px solid #fff;
    border-radius: 11px;
    background: #f56c6c;
    color: #fff;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    box-sizing: border-box;
  }
}
</style>
